import { ColorBadge } from "@atoms/index"

import { objectColorSchemeStatus } from "@constants/colorByStatus"

import { ObjectStatusBadgeProps } from "./ObjectStatusBadge.types"

export default function ObjectStatusBadge(props: ObjectStatusBadgeProps) {
    const { status, statusLabelOverride, size = "md" } = props

    return (
        <ColorBadge colorScheme={objectColorSchemeStatus[status]} size={size}>
            {statusLabelOverride ? statusLabelOverride : status}
        </ColorBadge>
    )
}
